import { EventType } from "@relieftelemed/platform";

const VACCINATION_EVENT = "Covid Vaccination";

export const isVaccinationEventType = (eventType?: EventType) => {
  return eventType?.name === VACCINATION_EVENT;
};
